import { theme } from "antd";
import React, { HTMLAttributes } from "react";

export const ArrowBackground: React.FC<HTMLAttributes<HTMLOrSVGElement>> = (
  props
) => {
  const { token } = theme.useToken();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="220"
      height="134"
      viewBox="0 0 220 134"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_2822_3063)">
        <path
          d="M50.1679 38.9734C50.0179 39.8168 49.2275 40.3912 48.375 40.2821C47.5151 40.1512 46.926 39.3551 47.0578 38.5008C47.1895 37.6465 47.9908 37.0613 48.8506 37.1921C49.5312 37.2939 50.0654 37.8247 50.1679 38.5008C50.2045 38.6571 50.2045 38.8171 50.1679 38.9734Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M50.1637 29.5957C50.182 30.4572 49.4941 31.1734 48.6269 31.1952C47.7598 31.2134 47.039 30.5299 47.017 29.6684C46.9987 28.8068 47.6829 28.0907 48.5538 28.0688H48.6269C49.4758 28.0688 50.1637 28.7523 50.1637 29.5957Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M50.1679 20.2519C50.285 21.1062 49.6812 21.895 48.8214 22.0114C47.9798 22.124 47.2005 21.5569 47.0578 20.7245C47.0212 20.5681 47.0212 20.4082 47.0578 20.2519C46.9114 19.4012 47.4895 18.5942 48.3457 18.4488C49.2019 18.3034 50.0142 18.8777 50.1605 19.7284C50.1605 19.7466 50.1679 19.7611 50.1679 19.7793C50.2045 19.9356 50.2045 20.0956 50.1679 20.2519Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M69.0075 29.5957C69.0258 30.4572 68.3379 31.1734 67.4707 31.1952C66.6035 31.2134 65.8827 30.5299 65.8608 29.6684C65.8425 28.8068 66.5267 28.0907 67.3975 28.0688H67.4341C68.283 28.087 68.9709 28.7559 69.0075 29.5957Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M69.0078 10.9099C69.0078 11.7714 68.3016 12.473 67.4345 12.473C66.5673 12.473 65.8611 11.7714 65.8611 10.9099C65.8611 10.0483 66.5673 9.34668 67.4345 9.34668C68.3016 9.34668 69.0078 10.0483 69.0078 10.9099Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M59.6094 10.9099C59.6094 11.7714 58.9032 12.473 58.036 12.473C57.1689 12.473 56.4627 11.7714 56.4627 10.9099C56.4627 10.0483 57.1689 9.34668 58.036 9.34668C58.9032 9.34668 59.6094 10.0483 59.6094 10.9099Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M50.1641 10.9099C50.1641 11.7714 49.4579 12.473 48.5907 12.473C47.7235 12.473 47.0174 11.7714 47.0174 10.9099C47.0174 10.0483 47.7235 9.34668 48.5907 9.34668H48.6273C49.4762 9.34668 50.1641 10.0301 50.1641 10.8735"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M69.0078 1.56708C69.0078 2.42864 68.3016 3.13025 67.4345 3.13025C66.5673 3.13025 65.8611 2.42864 65.8611 1.56708C65.8611 0.705515 66.5673 0.00390625 67.4345 0.00390625C68.3016 0.00390625 69.0078 0.705515 69.0078 1.56708Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M59.6094 1.56708C59.6094 2.42864 58.9032 3.13025 58.036 3.13025C57.1689 3.13025 56.4627 2.42864 56.4627 1.56708C56.4627 0.705515 57.1689 0.00390625 58.036 0.00390625C58.9032 0.00390625 59.6094 0.705515 59.6094 1.56708Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M50.1641 1.56708C50.1641 2.42864 49.4579 3.13025 48.5907 3.13025C47.7235 3.13025 47.0174 2.42864 47.0174 1.56708C47.0174 0.705515 47.7235 0.00390625 48.5907 0.00390625H48.6273C49.4762 0.00390625 50.1641 0.687339 50.1641 1.53072"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M69.0078 38.9734C69.0078 39.8349 68.3016 40.5365 67.4345 40.5365C66.5673 40.5365 65.8611 39.8349 65.8611 38.9734C65.8611 38.1118 66.5673 37.4102 67.4345 37.4102C68.2833 37.3884 68.9859 38.0573 69.0078 38.9007V38.9734Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M69.0078 20.2516C69.0078 21.1132 68.3016 21.8148 67.4345 21.8148C66.5673 21.8148 65.8611 21.1132 65.8611 20.2516C65.8611 19.3901 66.5673 18.6885 67.4345 18.6885C68.3016 18.6885 69.0078 19.3901 69.0078 20.2516Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M59.6094 38.9737C59.5728 39.8135 58.8849 40.4824 58.036 40.5006C57.1762 40.6169 56.3822 40.0171 56.2651 39.1628C56.1517 38.3267 56.7225 37.5523 57.5604 37.4106C57.7177 37.3742 57.8787 37.3742 58.036 37.4106C58.9032 37.4106 59.6094 38.1122 59.6094 38.9737Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M59.606 29.5951C59.6645 30.5185 58.9584 31.3109 58.0326 31.3691C57.1069 31.4273 56.3056 30.7257 56.2471 29.8059C56.1958 28.9844 56.752 28.25 57.557 28.0683C57.7143 28.0319 57.8753 28.0319 58.0326 28.0683C58.8815 28.0865 59.5694 28.7553 59.606 29.5951Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M59.6094 20.2516C59.6094 21.1132 58.9032 21.8148 58.036 21.8148C57.1689 21.8148 56.4627 21.1132 56.4627 20.2516C56.4627 19.3901 57.1689 18.6885 58.036 18.6885C58.8959 18.7067 59.5911 19.3974 59.6094 20.2516Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M3.14844 67.0021C3.14844 67.8637 2.44226 68.5653 1.57509 68.5653C0.707923 68.5653 0.00175095 67.8637 0.00175095 67.0021C0.00175095 66.1406 0.707923 65.439 1.57509 65.439C2.44226 65.439 3.14844 66.1406 3.14844 67.0021Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M3.14844 76.3449C3.14844 77.2065 2.44226 77.9081 1.57509 77.9081C0.707923 77.9081 0.00175095 77.2065 0.00175095 76.3449C0.00175095 75.4833 0.707923 74.7817 1.57509 74.7817C2.44226 74.7817 3.14844 75.4833 3.14844 76.3449Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M3.14844 57.6599C3.14844 58.5214 2.44226 59.223 1.57509 59.223C0.707923 59.223 0.00175095 58.5214 0.00175095 57.6599C0.00175095 56.7983 0.707923 56.0967 1.57509 56.0967C2.44226 56.0967 3.14844 56.7983 3.14844 57.6599Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M3.14844 48.3173C3.14844 49.1789 2.44959 49.8805 1.57876 49.8841C0.707927 49.8877 0.00540996 49.1898 0.00175095 48.3246V48.3173C0.00175095 47.4557 0.700602 46.7541 1.57143 46.7505C2.44226 46.7469 3.14478 47.4448 3.14844 48.31V48.3173Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M3.14844 85.6874C3.14844 86.549 2.44959 87.2506 1.57876 87.2542C0.707927 87.2579 0.00540996 86.5599 0.00175095 85.6947V85.6874C0.00175095 84.8259 0.700602 84.1243 1.57143 84.1206C2.44226 84.117 3.14478 84.815 3.14844 85.6802V85.6874Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M3.14808 95.0293C3.16638 95.8908 2.47851 96.607 1.61134 96.6288C0.744171 96.6506 0.023349 95.9635 0.00139546 95.102C-0.0168993 94.2404 0.667328 93.5243 1.53816 93.5024H1.57474C2.42361 93.5206 3.11149 94.1895 3.14808 95.0293Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M31.3594 123.093C31.3594 123.955 30.6532 124.657 29.786 124.657C28.9189 124.657 28.2127 123.955 28.2127 123.093C28.2127 122.232 28.9189 121.53 29.786 121.53C30.6532 121.53 31.3594 122.232 31.3594 123.093Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M40.7656 123.095C40.7656 123.956 40.0595 124.658 39.1923 124.658C38.3251 124.658 37.6189 123.956 37.6189 123.095C37.6189 122.233 38.3251 121.532 39.1923 121.532C40.0595 121.532 40.7656 122.233 40.7656 123.095Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M59.6094 123.095C59.6094 123.957 58.9032 124.659 58.036 124.659C57.1689 124.659 56.4627 123.957 56.4627 123.095C56.4627 122.234 57.1689 121.532 58.036 121.532C58.9032 121.532 59.6094 122.234 59.6094 123.095Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M40.7656 132.438C40.7656 133.299 40.0595 134.001 39.1923 134.001C38.3251 134.001 37.6189 133.299 37.6189 132.438C37.6189 131.576 38.3251 130.875 39.1923 130.875C40.0595 130.875 40.7656 131.576 40.7656 132.438Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M12.5547 67.0021C12.5547 67.8637 11.8485 68.5653 10.9813 68.5653C10.1142 68.5653 9.408 67.8637 9.408 67.0021C9.408 66.1406 10.1142 65.439 10.9813 65.439C11.8485 65.439 12.5547 66.1406 12.5547 67.0021Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M50.1641 67.0021C50.1641 67.8637 49.4579 68.5653 48.5907 68.5653C47.7235 68.5653 47.0174 67.8637 47.0174 67.0021C47.0174 66.1406 47.7235 65.439 48.5907 65.439H48.6273C49.4762 65.439 50.1641 66.1224 50.1641 66.9658"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M12.5547 48.3176C12.5547 49.1791 11.8485 49.8807 10.9813 49.8807C10.1142 49.8807 9.408 49.1791 9.408 48.3176C9.408 47.456 10.1142 46.7544 10.9813 46.7544C11.8485 46.7544 12.5547 47.456 12.5547 48.3176Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M12.5547 20.2516C12.5547 21.1132 11.8485 21.8148 10.9813 21.8148C10.1142 21.8148 9.408 21.1132 9.408 20.2516C9.408 19.3901 10.1142 18.6885 10.9813 18.6885C11.8485 18.6885 12.5547 19.3901 12.5547 20.2516Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M3.14844 20.2514C3.14844 21.1129 2.44959 21.8145 1.57876 21.8182C0.711586 21.8182 0.00540996 21.1238 0.00175095 20.2586V20.2514C0.00175095 19.3898 0.700602 18.6882 1.57143 18.6846C2.4386 18.6846 3.14478 19.3789 3.14844 20.2441V20.2514Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M12.5547 76.3449C12.5547 77.2065 11.8485 77.9081 10.9813 77.9081C10.1142 77.9081 9.408 77.2065 9.408 76.3449C9.408 75.4833 10.1142 74.7817 10.9813 74.7817C11.8485 74.7817 12.5547 75.4833 12.5547 76.3449Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M12.5547 57.6599C12.5547 58.5214 11.8485 59.223 10.9813 59.223C10.1142 59.223 9.408 58.5214 9.408 57.6599C9.408 56.7983 10.1142 56.0967 10.9813 56.0967C11.8485 56.0967 12.5547 56.7983 12.5547 57.6599Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M12.5543 29.5957C12.5726 30.4572 11.8847 31.1734 11.0176 31.1952C10.1504 31.2134 9.4296 30.5299 9.40765 29.6684C9.38935 28.8068 10.0736 28.0907 10.9444 28.0688H10.981C11.8299 28.087 12.5177 28.7559 12.5543 29.5957Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M3.14808 29.5957C3.16638 30.4572 2.47851 31.1734 1.61134 31.1952C0.744171 31.2134 0.023349 30.5299 0.00139546 29.6684C-0.0168993 28.8068 0.667328 28.0907 1.53816 28.0688H1.57474C2.42361 28.087 3.11149 28.7559 3.14808 29.5957Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M12.5547 38.9734C12.5547 39.8349 11.8485 40.5365 10.9813 40.5365C10.1142 40.5365 9.408 39.8349 9.408 38.9734C9.408 38.1118 10.1142 37.4102 10.9813 37.4102C11.8302 37.3884 12.5327 38.0573 12.5547 38.9007V38.9734Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M3.14844 38.9734C3.14844 39.8349 2.44226 40.5365 1.57509 40.5365C0.707923 40.5365 0.00175095 39.8349 0.00175095 38.9734C0.00175095 38.1118 0.707923 37.4102 1.57509 37.4102C2.42397 37.3884 3.12648 38.0573 3.14844 38.9007V38.9734Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M12.5547 10.9099C12.5547 11.7714 11.8485 12.473 10.9813 12.473C10.1142 12.473 9.408 11.7714 9.408 10.9099C9.408 10.0483 10.1142 9.34668 10.9813 9.34668C11.8485 9.34668 12.5547 10.0483 12.5547 10.9099Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M3.14844 10.9099C3.14844 11.7714 2.44226 12.473 1.57509 12.473C0.707923 12.473 0.00175095 11.7714 0.00175095 10.9099C0.00175095 10.0483 0.707923 9.34668 1.57509 9.34668C2.44226 9.34668 3.14844 10.0483 3.14844 10.9099Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M21.9531 10.9099C21.9531 11.7714 21.247 12.473 20.3798 12.473C19.5126 12.473 18.8064 11.7714 18.8064 10.9099C18.8064 10.0483 19.5126 9.34668 20.3798 9.34668C21.247 9.34668 21.9531 10.0483 21.9531 10.9099Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M12.5547 1.56708C12.5547 2.42864 11.8558 3.13025 10.985 3.13388C10.1142 3.13752 9.41166 2.43954 9.408 1.57435V1.56708C9.408 0.705515 10.1142 0.00390625 10.9813 0.00390625C11.8485 0.00390625 12.5547 0.705515 12.5547 1.56708Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M3.14844 1.56708C3.14844 2.42864 2.44959 3.13025 1.57876 3.13388C0.707927 3.13752 0.00540996 2.43954 0.00175095 1.57435V1.56708C0.00175095 0.705515 0.707923 0.00390625 1.57509 0.00390625C2.44226 0.00390625 3.14844 0.705515 3.14844 1.56708Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M21.9531 1.56708C21.9531 2.42864 21.2433 3.13025 20.3761 3.12661C19.5089 3.12661 18.8101 2.42864 18.8064 1.56708C18.8064 0.705515 19.5126 0.00390625 20.3798 0.00390625C21.247 0.00390625 21.9531 0.705515 21.9531 1.56708Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M12.5547 85.6877C12.5547 86.5492 11.8485 87.2508 10.9813 87.2508C10.1142 87.2508 9.408 86.5492 9.408 85.6877C9.408 84.8261 10.1142 84.1245 10.9813 84.1245C11.8485 84.1245 12.5547 84.8261 12.5547 85.6877Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M12.5543 95.0293C12.5726 95.8908 11.8847 96.607 11.0176 96.6288C10.1504 96.6506 9.4296 95.9635 9.40765 95.102C9.38935 94.2404 10.0736 93.5243 10.9444 93.5024H10.981C11.8299 93.5206 12.5177 94.1895 12.5543 95.0293Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M69.0075 95.0293C69.0258 95.8908 68.3379 96.607 67.4707 96.6288C66.6035 96.647 65.8827 95.9635 65.8608 95.102C65.8425 94.2404 66.5267 93.5243 67.3975 93.5024H67.4341C68.283 93.5206 68.9709 94.1895 69.0075 95.0293Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M12.5547 104.409C12.5547 105.27 11.8485 105.972 10.9813 105.972C10.1142 105.972 9.408 105.27 9.408 104.409C9.408 103.547 10.1142 102.846 10.9813 102.846C11.8302 102.824 12.5327 103.493 12.5547 104.336V104.409Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M31.3594 48.3173C31.3594 49.1789 30.6532 49.8805 29.786 49.8805C28.9262 49.8623 28.231 49.1716 28.2127 48.3173C28.2127 47.4557 28.9115 46.7541 29.7824 46.7505C30.6532 46.7469 31.3557 47.4448 31.3594 48.31V48.3173Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M59.6094 48.3176C59.5911 49.1719 58.8959 49.8626 58.036 49.8807C57.1689 49.8807 56.4627 49.1791 56.4627 48.3176C56.4627 47.456 57.1689 46.7544 58.036 46.7544C58.9032 46.7544 59.6094 47.456 59.6094 48.3176Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M31.356 29.5951C31.4145 30.5185 30.7084 31.3109 29.7826 31.3691C28.8533 31.4273 28.0556 30.7257 27.9971 29.8059C27.9458 28.9844 28.502 28.25 29.307 28.0683C29.4643 28.0319 29.6253 28.0319 29.7826 28.0683C30.6315 28.0465 31.334 28.7154 31.356 29.5587"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M40.7667 29.5954C40.8838 30.4497 40.2801 31.2386 39.4202 31.3549C38.5787 31.4676 37.7993 30.9005 37.6566 30.068C37.62 29.9117 37.62 29.7517 37.6566 29.5954C37.8066 28.752 38.597 28.1776 39.4495 28.2867C40.1337 28.3776 40.6753 28.9156 40.7667 29.5954Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M31.3594 76.3449C31.3594 77.2065 30.6532 77.9081 29.786 77.9081C28.9189 77.9081 28.2127 77.2065 28.2127 76.3449C28.2127 75.4833 28.9189 74.7817 29.786 74.7817C30.6532 74.7817 31.3594 75.4833 31.3594 76.3449Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M31.3594 57.6599C31.3594 58.5214 30.6532 59.223 29.786 59.223C28.9189 59.223 28.2127 58.5214 28.2127 57.6599C28.2127 56.7983 28.9189 56.0967 29.786 56.0967C30.6532 56.0967 31.3594 56.7983 31.3594 57.6599Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M31.3594 38.9737C31.3594 39.8171 30.6715 40.5006 29.8226 40.5006H29.786C28.9298 40.646 28.1175 40.0716 27.9712 39.2209C27.8248 38.3703 28.4029 37.5632 29.2591 37.4178C29.2774 37.4178 29.2921 37.4106 29.3104 37.4106C29.4677 37.3742 29.6287 37.3742 29.786 37.4106C30.6532 37.4106 31.3594 38.1122 31.3594 38.9737Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M31.3594 10.9099C31.3594 11.7714 30.6532 12.473 29.786 12.473C28.9189 12.473 28.2127 11.7714 28.2127 10.9099C28.2127 10.0483 28.9189 9.34668 29.786 9.34668C30.6532 9.34668 31.3594 10.0483 31.3594 10.9099Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M31.3594 1.56682C31.3594 2.42838 30.6605 3.12999 29.7897 3.13362C28.9188 3.13726 28.2163 2.43929 28.2127 1.57409V1.56682C28.2127 0.705258 28.9115 0.00364942 29.7824 1.4136e-05C30.6532 -0.00362114 31.3557 0.694353 31.3594 1.55955V1.56682Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M40.7656 10.9099C40.7656 11.7714 40.0595 12.473 39.1923 12.473C38.3251 12.473 37.6189 11.7714 37.6189 10.9099C37.6189 10.0483 38.3251 9.34668 39.1923 9.34668C40.0595 9.34668 40.7656 10.0483 40.7656 10.9099Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M40.7656 1.56708C40.7656 2.42864 40.0595 3.13025 39.1923 3.13025C38.3251 3.13025 37.6189 2.42864 37.6189 1.56708C37.6189 0.705515 38.3251 0.00390625 39.1923 0.00390625C40.0595 0.00390625 40.7656 0.705515 40.7656 1.56708Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M31.3594 85.6877C31.3594 86.5492 30.6605 87.2509 29.7897 87.2545C28.9188 87.2581 28.2163 86.5601 28.2127 85.6949V85.6877C28.231 84.8334 28.9262 84.1427 29.786 84.1245C30.6532 84.1245 31.3594 84.8261 31.3594 85.6877Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M31.356 95.0298C31.4145 95.9531 30.7084 96.7456 29.7826 96.8038C28.8569 96.862 28.0556 96.1603 27.9971 95.2406C27.9458 94.419 28.502 93.6847 29.307 93.503H29.7826C30.6315 93.4811 31.334 94.15 31.356 94.9934"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M50.1637 95.0293C50.182 95.8908 49.4941 96.607 48.6269 96.6288C47.7598 96.647 47.039 95.9635 47.017 95.102C46.9987 94.2404 47.6829 93.5243 48.5538 93.5024H48.6269C49.4758 93.5024 50.1637 94.1859 50.1637 95.0293Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M31.3594 104.408C31.3594 105.252 30.6715 105.935 29.8226 105.935H29.786C28.9298 106.081 28.1175 105.506 27.9712 104.656C27.8248 103.805 28.4029 102.998 29.2591 102.852C29.2774 102.852 29.2921 102.845 29.3104 102.845H29.786C30.6532 102.845 31.3594 103.547 31.3594 104.408Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M31.3594 113.751C31.3594 114.613 30.6532 115.314 29.786 115.314C28.9262 115.296 28.231 114.605 28.2127 113.751C28.2127 112.889 28.9225 112.188 29.7897 112.191C30.6568 112.191 31.3557 112.889 31.3594 113.751Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M50.1679 113.751C50.3142 114.602 49.7361 115.409 48.8799 115.554C48.0237 115.7 47.2114 115.125 47.0651 114.275C47.0651 114.257 47.0578 114.242 47.0578 114.224C47.0212 114.068 47.0212 113.908 47.0578 113.751C46.9407 112.897 47.5444 112.108 48.4043 111.992C49.2458 111.879 50.0252 112.446 50.1679 113.279C50.2045 113.435 50.2045 113.595 50.1679 113.751Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M21.9531 67.0021C21.9531 67.8637 21.247 68.5653 20.3798 68.5653C19.5126 68.5653 18.8064 67.8637 18.8064 67.0021C18.8064 66.1406 19.5126 65.439 20.3798 65.439C21.247 65.439 21.9531 66.1406 21.9531 67.0021Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M21.9531 48.3176C21.9531 49.1791 21.247 49.8807 20.3798 49.8807C19.5126 49.8807 18.8064 49.1791 18.8064 48.3176C18.8064 47.456 19.5126 46.7544 20.3798 46.7544C21.247 46.7544 21.9531 47.456 21.9531 48.3176Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M21.9528 29.5957C21.9711 30.4572 21.2832 31.1734 20.416 31.1952C19.5488 31.2134 18.828 30.5299 18.8061 29.6684C18.7878 28.8068 19.472 28.0907 20.3428 28.0688H20.3794C21.2283 28.087 21.9162 28.7559 21.9528 29.5957Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M21.9531 76.3449C21.9531 77.2065 21.247 77.9081 20.3798 77.9081C19.5126 77.9081 18.8064 77.2065 18.8064 76.3449C18.8064 75.4833 19.5126 74.7817 20.3798 74.7817C21.247 74.7817 21.9531 75.4833 21.9531 76.3449Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M21.9531 57.6599C21.9531 58.5214 21.247 59.223 20.3798 59.223C19.5126 59.223 18.8064 58.5214 18.8064 57.6599C18.8064 56.7983 19.5126 56.0967 20.3798 56.0967C21.247 56.0967 21.9531 56.7983 21.9531 57.6599Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M21.9531 38.9734C21.9531 39.8349 21.247 40.5365 20.3798 40.5365C19.5126 40.5365 18.8064 39.8349 18.8064 38.9734C18.8064 38.1118 19.5126 37.4102 20.3798 37.4102C21.2287 37.3884 21.9312 38.0573 21.9531 38.9007V38.9734Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M21.9531 20.2516C21.9531 21.1132 21.247 21.8148 20.3798 21.8148C19.5126 21.8148 18.8064 21.1132 18.8064 20.2516C18.8064 19.3901 19.5126 18.6885 20.3798 18.6885C21.247 18.6885 21.9531 19.3901 21.9531 20.2516Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M31.3594 20.2516C31.3594 21.1132 30.6605 21.8148 29.7897 21.8185C28.9225 21.8185 28.2163 21.1241 28.2127 20.2589V20.2516C28.231 19.3974 28.9262 18.7067 29.786 18.6885C30.6532 18.6885 31.3594 19.3901 31.3594 20.2516Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M40.7616 20.2519C40.8787 21.1062 40.275 21.895 39.4151 22.0114C38.5736 22.124 37.7942 21.5569 37.6515 20.7245C37.6149 20.5681 37.6149 20.4082 37.6515 20.2519C37.5052 19.4012 38.0833 18.5942 38.9395 18.4488C39.7957 18.3034 40.6079 18.8777 40.7543 19.7284C40.7543 19.7466 40.7616 19.7611 40.7616 19.7793C40.7982 19.9356 40.7982 20.0956 40.7616 20.2519Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M21.9531 85.6877C21.9531 86.5492 21.247 87.2508 20.3798 87.2508C19.5126 87.2508 18.8064 86.5492 18.8064 85.6877C18.8064 84.8261 19.5126 84.1245 20.3798 84.1245C21.247 84.1245 21.9531 84.8261 21.9531 85.6877Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M21.9528 95.0293C21.9711 95.8908 21.2832 96.607 20.416 96.6288C19.5488 96.6506 18.828 95.9635 18.8061 95.102C18.7878 94.2404 19.472 93.5243 20.3428 93.5024H20.3794C21.2283 93.5206 21.9162 94.1895 21.9528 95.0293Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M21.9531 104.409C21.9531 105.27 21.247 105.972 20.3798 105.972C19.5126 105.972 18.8064 105.27 18.8064 104.409C18.8064 103.547 19.5126 102.846 20.3798 102.846C21.2287 102.824 21.9312 103.493 21.9531 104.336V104.409Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M21.9531 113.753C21.9531 114.614 21.2433 115.316 20.3761 115.312C19.5089 115.312 18.8101 114.614 18.8064 113.753C18.8064 112.891 19.5163 112.19 20.3834 112.193C21.2506 112.193 21.9495 112.891 21.9531 113.753Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M40.7656 67.0021C40.7656 67.8637 40.0595 68.5653 39.1923 68.5653C38.3251 68.5653 37.6189 67.8637 37.6189 67.0021C37.6189 66.1406 38.3251 65.439 39.1923 65.439C40.0595 65.439 40.7656 66.1406 40.7656 67.0021Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M40.7616 48.3173C40.8787 49.1716 40.275 49.9605 39.4151 50.0768C38.5736 50.1895 37.7942 49.6224 37.6515 48.7899C37.6149 48.6336 37.6149 48.4736 37.6515 48.3173C37.5052 47.4667 38.0833 46.6596 38.9395 46.5142C39.7957 46.3688 40.6079 46.9432 40.7543 47.7938C40.7543 47.812 40.7616 47.8265 40.7616 47.8447C40.7982 48.001 40.7982 48.161 40.7616 48.3173Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M40.7656 76.3449C40.7656 77.2065 40.0595 77.9081 39.1923 77.9081C38.3251 77.9081 37.6189 77.2065 37.6189 76.3449C37.6189 75.4833 38.3251 74.7817 39.1923 74.7817C40.0595 74.7817 40.7656 75.4833 40.7656 76.3449Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M97.2188 67.0021C97.2188 67.8637 96.5126 68.5653 95.6454 68.5653C94.7782 68.5653 94.0721 67.8637 94.0721 67.0021C94.0721 66.1406 94.7782 65.439 95.6454 65.439C96.5126 65.439 97.2188 66.1406 97.2188 67.0021Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M40.7656 57.6599C40.7656 58.5214 40.0595 59.223 39.1923 59.223C38.3251 59.223 37.6189 58.5214 37.6189 57.6599C37.6189 56.7983 38.3251 56.0967 39.1923 56.0967C40.0595 56.0967 40.7656 56.7983 40.7656 57.6599Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M40.7656 38.9734C40.7656 39.8349 40.0595 40.5365 39.1923 40.5365C38.3251 40.5365 37.6189 39.8349 37.6189 38.9734C37.6189 38.1118 38.3251 37.4102 39.1923 37.4102C40.0412 37.3884 40.7437 38.0573 40.7656 38.9007V38.9734Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M40.7616 85.6869C40.908 86.5376 40.3299 87.3446 39.4737 87.49C38.6175 87.6354 37.8052 87.0611 37.6588 86.2104C37.6588 86.1922 37.6515 86.1777 37.6515 86.1595C37.6149 86.0032 37.6149 85.8433 37.6515 85.6869C37.5052 84.8363 38.0833 84.0293 38.9395 83.8838C39.7957 83.7384 40.6079 84.3128 40.7543 85.1635C40.7543 85.1816 40.7616 85.1962 40.7616 85.2144C40.7982 85.3707 40.7982 85.5306 40.7616 85.6869Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M40.7656 104.409C40.7656 105.27 40.0595 105.972 39.1923 105.972C38.3251 105.972 37.6189 105.27 37.6189 104.409C37.6189 103.547 38.3251 102.846 39.1923 102.846C40.0412 102.824 40.7437 103.493 40.7656 104.336V104.409Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M40.7616 113.75C40.908 114.601 40.3299 115.408 39.4737 115.554C38.6175 115.699 37.8052 115.125 37.6588 114.274C37.6588 114.256 37.6515 114.241 37.6515 114.223C37.6149 114.067 37.6149 113.907 37.6515 113.75C37.5052 112.9 38.0833 112.093 38.9395 111.947C39.7957 111.802 40.6079 112.376 40.7543 113.227C40.7543 113.245 40.7616 113.26 40.7616 113.278C40.7982 113.434 40.7982 113.594 40.7616 113.75Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M97.2188 38.9737C97.2188 39.8171 96.5309 40.5006 95.682 40.5006H95.6454C94.7892 40.646 93.9769 40.0716 93.8306 39.2209C93.6842 38.3703 94.2623 37.5632 95.1185 37.4178C95.1368 37.4178 95.1514 37.4106 95.1697 37.4106C95.3271 37.3742 95.4881 37.3742 95.6454 37.4106C96.5126 37.4106 97.2188 38.1122 97.2188 38.9737Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M97.2232 29.5951C97.2817 30.5185 96.5755 31.3109 95.6498 31.3691C94.7241 31.4273 93.9228 30.7257 93.8642 29.8059C93.813 28.9844 94.3692 28.25 95.1742 28.0683C95.3315 28.0319 95.4925 28.0319 95.6498 28.0683C96.4987 28.0465 97.2012 28.7154 97.2232 29.5587"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M97.2188 20.2516C97.2188 21.1132 96.5126 21.8148 95.6454 21.8148C94.7782 21.8148 94.0721 21.1132 94.0721 20.2516C94.0903 19.3974 94.7855 18.7067 95.6454 18.6885C96.5126 18.6885 97.2188 19.3901 97.2188 20.2516Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M78.4137 29.5957C78.432 30.4572 77.7441 31.1734 76.877 31.1952C76.0098 31.2134 75.289 30.5299 75.267 29.6684C75.2487 28.8068 75.9329 28.0907 76.8038 28.0688H76.8404C77.6892 28.087 78.3771 28.7559 78.4137 29.5957Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M78.4141 10.9099C78.4141 11.7714 77.7079 12.473 76.8407 12.473C75.9735 12.473 75.2674 11.7714 75.2674 10.9099C75.2674 10.0483 75.9735 9.34668 76.8407 9.34668C77.7079 9.34668 78.4141 10.0483 78.4141 10.9099Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M87.8203 10.9099C87.8203 11.7714 87.1141 12.473 86.247 12.473C85.3798 12.473 84.6736 11.7714 84.6736 10.9099C84.6736 10.0483 85.3798 9.34668 86.247 9.34668C87.1141 9.34668 87.8203 10.0483 87.8203 10.9099Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M97.2188 10.9099C97.2188 11.7714 96.5126 12.473 95.6454 12.473C94.7782 12.473 94.0721 11.7714 94.0721 10.9099C94.0721 10.0483 94.7782 9.34668 95.6454 9.34668C96.5126 9.34668 97.2188 10.0483 97.2188 10.9099Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M78.4141 1.56708C78.4141 2.42864 77.7079 3.13025 76.8407 3.13025C75.9735 3.13025 75.2674 2.42864 75.2674 1.56708C75.2674 0.705515 75.9735 0.00390625 76.8407 0.00390625C77.7079 0.00390625 78.4141 0.705515 78.4141 1.56708Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M87.8203 1.56708C87.8203 2.42864 87.1141 3.13025 86.247 3.13025C85.3798 3.13025 84.6736 2.42864 84.6736 1.56708C84.6736 0.705515 85.3798 0.00390625 86.247 0.00390625C87.1141 0.00390625 87.8203 0.705515 87.8203 1.56708Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M97.2188 1.56708C97.2188 2.42864 96.5126 3.13025 95.6454 3.13025C94.7782 3.13025 94.0721 2.42864 94.0721 1.56708C94.0721 0.705515 94.7782 0.00390625 95.6454 0.00390625C96.5126 0.00390625 97.2188 0.705515 97.2188 1.56708Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M78.4141 38.9734C78.4141 39.8349 77.7079 40.5365 76.8407 40.5365C75.9735 40.5365 75.2674 39.8349 75.2674 38.9734C75.2674 38.1118 75.9735 37.4102 76.8407 37.4102C77.6896 37.3884 78.3921 38.0573 78.4141 38.9007V38.9734Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M78.4141 20.2516C78.4141 21.1132 77.7079 21.8148 76.8407 21.8148C75.9735 21.8148 75.2674 21.1132 75.2674 20.2516C75.2674 19.3901 75.9735 18.6885 76.8407 18.6885C77.7079 18.6885 78.4141 19.3901 78.4141 20.2516Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M87.82 29.5957C87.8383 30.4572 87.1504 31.1734 86.2832 31.1952C85.416 31.2134 84.6952 30.5299 84.6733 29.6684C84.655 28.8068 85.3392 28.0907 86.21 28.0688H86.2466C87.0955 28.087 87.7834 28.7559 87.82 29.5957Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M87.8203 20.2516C87.8203 21.1132 87.1141 21.8148 86.247 21.8148C85.3798 21.8148 84.6736 21.1132 84.6736 20.2516C84.6736 19.3901 85.3798 18.6885 86.247 18.6885C87.1141 18.6885 87.8203 19.3901 87.8203 20.2516Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M144.273 48.3176C144.273 49.1791 143.567 49.8807 142.7 49.8807C141.833 49.8807 141.127 49.1791 141.127 48.3176C141.127 47.456 141.833 46.7544 142.7 46.7544C143.567 46.7544 144.273 47.456 144.273 48.3176Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M134.875 38.9734C134.875 39.8349 134.169 40.5365 133.302 40.5365C132.434 40.5365 131.728 39.8349 131.728 38.9734C131.728 38.1118 132.434 37.4102 133.302 37.4102C134.151 37.3884 134.853 38.0573 134.875 38.9007V38.9734Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M106.621 85.6863C106.738 86.5406 106.134 87.3295 105.275 87.4458C104.433 87.5585 103.654 86.9914 103.511 86.1589C103.474 86.0026 103.474 85.8427 103.511 85.6863C103.394 84.832 103.998 84.0432 104.857 83.9269C105.699 83.8142 106.478 84.3813 106.621 85.2137C106.658 85.3701 106.658 85.53 106.621 85.6863Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M106.626 29.5954C106.772 30.4461 106.194 31.2531 105.338 31.3985C104.482 31.5439 103.669 30.9695 103.523 30.1189C103.523 30.1007 103.516 30.0862 103.516 30.068C103.479 29.9117 103.479 29.7517 103.516 29.5954C103.666 28.752 104.456 28.1776 105.309 28.2867C105.993 28.3776 106.534 28.9156 106.626 29.5954Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M116.027 38.9734C115.877 39.8168 115.087 40.3912 114.234 40.2821C113.375 40.1512 112.785 39.3551 112.917 38.5008C113.049 37.6465 113.85 37.0613 114.71 37.1921C115.391 37.2939 115.925 37.8247 116.027 38.5008C116.064 38.6571 116.064 38.8171 116.027 38.9734Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M106.625 10.9099C106.625 11.7714 105.919 12.473 105.052 12.473C104.184 12.473 103.478 11.7714 103.478 10.9099C103.478 10.0483 104.184 9.34668 105.052 9.34668C105.919 9.34668 106.625 10.0483 106.625 10.9099Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M125.465 29.5951C125.524 30.5185 124.818 31.3109 123.892 31.3691C122.966 31.4273 122.165 30.7257 122.106 29.8059C122.055 28.9844 122.611 28.25 123.416 28.0683C123.574 28.0319 123.735 28.0319 123.892 28.0683C124.741 28.0865 125.429 28.7553 125.465 29.5951Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M125.469 38.9737C125.432 39.8135 124.744 40.4824 123.895 40.5006C123.039 40.646 122.227 40.0716 122.081 39.2209C121.934 38.3703 122.512 37.5632 123.369 37.4178C123.387 37.4178 123.401 37.4106 123.42 37.4106C123.577 37.3742 123.738 37.3742 123.895 37.4106C124.763 37.4106 125.469 38.1122 125.469 38.9737Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M116.027 20.2508C116.144 21.1051 115.541 21.8939 114.681 22.0103C113.839 22.123 113.06 21.5558 112.917 20.7234C112.881 20.5671 112.881 20.4071 112.917 20.2508C112.8 19.3965 113.404 18.6076 114.264 18.4913C115.105 18.3786 115.885 18.9457 116.027 19.7782C116.064 19.9345 116.064 20.0945 116.027 20.2508Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M106.621 20.2519C106.767 21.1025 106.189 21.9096 105.333 22.055C104.477 22.2004 103.665 21.626 103.518 20.7754C103.518 20.7572 103.511 20.7426 103.511 20.7245C103.474 20.5681 103.474 20.4082 103.511 20.2519C103.365 19.4012 103.943 18.5942 104.799 18.4488C105.655 18.3034 106.467 18.8777 106.614 19.7284C106.614 19.7466 106.621 19.7611 106.621 19.7793C106.658 19.9356 106.658 20.0956 106.621 20.2519Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M106.625 38.9734C106.625 39.8349 105.919 40.5365 105.052 40.5365C104.184 40.5365 103.478 39.8349 103.478 38.9734C103.478 38.1118 104.184 37.4102 105.052 37.4102C105.901 37.3884 106.603 38.0573 106.625 38.9007V38.9734Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M153.68 67.0021C153.68 67.8637 152.974 68.5653 152.106 68.5653C151.239 68.5653 150.533 67.8637 150.533 67.0021C150.533 66.1406 151.239 65.439 152.106 65.439C152.974 65.439 153.68 66.1406 153.68 67.0021Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M172.485 29.5954C172.603 30.4497 171.999 31.2386 171.139 31.3549C170.297 31.4676 169.518 30.9005 169.375 30.068C169.339 29.9117 169.339 29.7517 169.375 29.5954C169.525 28.752 170.316 28.1776 171.168 28.2867C171.852 28.3776 172.394 28.9156 172.485 29.5954Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M144.273 113.753C144.273 114.614 143.567 115.316 142.7 115.316C141.833 115.316 141.127 114.614 141.127 113.753C141.127 112.891 141.833 112.189 142.7 112.189C143.567 112.189 144.273 112.891 144.273 113.753Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M163.078 10.9099C163.078 11.7714 162.372 12.473 161.505 12.473C160.638 12.473 159.931 11.7714 159.931 10.9099C159.931 10.0483 160.638 9.34668 161.505 9.34668C162.372 9.34668 163.078 10.0483 163.078 10.9099Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M163.078 85.6877C163.078 86.5492 162.372 87.2508 161.505 87.2508C160.638 87.2508 159.931 86.5492 159.931 85.6877C159.95 84.8334 160.645 84.1427 161.505 84.1245C162.372 84.1245 163.078 84.8261 163.078 85.6877Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M163.078 123.095C163.078 123.957 162.372 124.659 161.505 124.659C160.638 124.659 159.931 123.957 159.931 123.095C159.931 122.234 160.638 121.532 161.505 121.532C162.372 121.532 163.078 122.234 163.078 123.095Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M219.539 76.3449C219.539 77.2065 218.833 77.9081 217.966 77.9081C217.099 77.9081 216.392 77.2065 216.392 76.3449C216.392 75.4833 217.099 74.7817 217.966 74.7817C218.833 74.7817 219.539 75.4833 219.539 76.3449Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M200.726 95.0293C200.745 95.8908 200.057 96.607 199.189 96.6288C198.322 96.647 197.601 95.9635 197.58 95.102C197.561 94.2404 198.245 93.5243 199.116 93.5024H199.153C200.002 93.5206 200.69 94.1895 200.726 95.0293Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
        <path
          d="M191.328 76.3449C191.328 77.2065 190.622 77.9081 189.755 77.9081C188.888 77.9081 188.181 77.2065 188.181 76.3449C188.181 75.4833 188.888 74.7817 189.755 74.7817C190.622 74.7817 191.328 75.4833 191.328 76.3449Z"
          fill={token.colorPrimary}
          fillOpacity="0.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_2822_3063">
          <rect
            width="219.537"
            height="134"
            fill="white"
            transform="matrix(-1 0 0 1 219.539 0)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
